import React from "react";
import { X } from "lucide-react";

type LightboxProps = {
  src: string | null;
  alt?: string;
  isOpen: boolean;
  onClose: () => void;
};

export function Lightbox({ src, alt = "", isOpen, onClose }: LightboxProps) {
  React.useEffect(() => {
    if (!isOpen) return;
    const key = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", key);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", key);
      document.body.style.overflow = "auto";
    };
  }, [isOpen, onClose]);

  if (!isOpen || !src) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80"
      onClick={onClose}
    >
      {/* close button */}
      <button
        onClick={onClose}
        aria-label="Close lightbox"
        className="absolute top-5 right-5 text-white bg-black/40 hover:bg-black/60 rounded-full p-2"
      >
        <X size={22} />
      </button>

      {/* image */}
      <img
        src={src}
        alt={alt}
        onClick={(e) => e.stopPropagation()}
        className="max-w-[95vw] max-h-[90vh] object-contain rounded-lg shadow-[0_10px_40px_rgba(0,0,0,0.5)] select-none"
        draggable={false}
        style={{
          cursor: "default",
          userSelect: "none",
          pointerEvents: "auto",
        }}
        onError={(e) => {
          (e.target as HTMLImageElement).src = "/placeholder.svg";
        }}
      />
    </div>
  );
}
